/**
 * VERSIONE LIBRERIA 3
 */

var ViewCollection = CoreView.extend({
    /**
     * inizializza le keys della view che rappresenta tutti i fields da renderizzare
     * @private
     */
    _setKeys : function () {
        var self = this;
        self.keys = self.config.fields; //Object.keys(self.config.fields);
        if (self.keys.length === 0) {
            if (self.data.value.length > 0 )
                self.keys = Object.keys(self.data.value[0]);
        }
    },
    /**
     * renderizza gli header delle colonne dati
     **/
    _renderHeaderValues : function (jQrow) {
        var self = this;

        var objH = $.createDynamicContainer('#'+self.prefixTemplateClass+'_view_list_header_tpl');
        var objO = $.createDynamicContainer('#'+self.prefixTemplateClass+'_view_list_order_tpl');
        var orderFields = self.config.order_fields?Object.keys(self.config.order_fields):[];
        // renderizzo i nomi
        //console.log('ACTION LAYOUT',self.config.actions_layout);
        $.each(jQrow.children('th'),function (index,th) {
            // se le azioni vengono renderizzate a sinistra devo saltare un indice
            if (self.config.actions_layout == 'left' && index === 0) {
                // la prima colonna la salto ;
            } else if (self.config.actions_layout == 'right' && index == self.visibleKeys.length) {
                // salto l'ultima colonna in caso di right
            } else {
                var i = (self.config.actions_layout == 'right')?index:index-1;
                var translateDef = $.translate(Utility.camelCase(self.modelName) + '-' + self.visibleKeys[i]);
                //console.log("check in array ",self.visibleKeys[i],$.inArray(self.visibleKeys[i],orderFields))
                if ($.inArray(self.visibleKeys[i],orderFields) >=0 ) {
                    objO.find('[data-pk]').attr('data-pk',self.visibleKeys[i]);
                    objO.find('[data-element]').html(translateDef);
                    $(th).html(objO.html());
                    if (self.data.resultParams.order_field == self.visibleKeys[i]) {
                        $(th).addClass('sorting_' + self.data.resultParams.order_direction.toLowerCase());
                        
                    } else
                        $(th).addClass('sorting');
                } else {
                    objH.find('[data-element]').html(translateDef);
                    $(th).html(objH.html());
                }
                $(th).addClass('field-'+self.visibleKeys[i]);
            }
        });
        objO.remove();
        objH.remove();
    },
    /**
     * renderizza gli header della colonna action
     **/
    _renderHeaderActions : function (jQrow) {
        var self = this;
        var colAction = (self.config.actions_layout != 'right')?0:self.visibleKeys.length;

        var azioniH = $.createDynamicContainer('#' + self.prefixTemplateClass + '_azioni_header_tpl');
        $(jQrow.children()[colAction]).html(azioniH.html());
        $(jQrow.children()[colAction]).attr('data-col_actions','');
        // in caso non ci sia niente da renderizzare, rimuovo la colonna
        if (! self._hasNeedSelectionAction() && ! self._hasRecordActions()) {
            $(jQrow.children()[colAction]).remove();
        } else {
            if (! self._hasNeedSelectionAction()) {
                $(jQrow.children()[colAction]).find('[data-button="checkAll"]').remove();
            } else {
                // aggiungo il check/uncheck delle righe
                $(jQrow.children()[colAction]).find('[data-button="checkAll"]').change(function () {
                    var check = $(this).prop('checked');
                    $(self.config.container).find('input[name="check_row"]').prop('checked',check);
                });
            }
        }
        azioniH.remove();
    },
    _renderHeader : function () {

        var self = this;
        var jQe = self.jQe;
        var row = jQe.find('[data-view_row_headers]');
        var col = row.find('th');

        // creo le colonne, da uno perche' c'e' gia' nel template
        for (var i=0;i<self.visibleKeys.length;i++) {
            col.clone().appendTo(row);
        }

        self._renderHeaderValues(row);
        self._renderHeaderActions(row);
    },

    _renderFooter : function () {
        var self = this;
        var jQe = self.jQe;

        if (!self.data.summary || Object.keys(self.data.summary).length == 0) {
            jQe.find('tfoot').remove();
            return ;
        }

        var row = jQe.find('[data-view_row_footer]');
        var col = row.find('td');

        // creo le colonne, da uno perche' c'e' gia' nel template
        for (var i=0;i<self.visibleKeys.length;i++) {
            col.clone().appendTo(row);
        }
        var summaryTplId = '#' + self.prefixTemplateClass +  "_view_summary_field_tpl";
        $.each(row.children('td'),function (index,td) {
            if (self.config.actions_layout == 'left' && index === 0) {
                // la prima colonna la salto ;
            } else if (self.config.actions_layout == 'right' && index == self.visibleKeys.length) {
                // salto l'ultima colonna in caso di right
            } else {
                //var i = (self.config.actions_layout == 'right')?index:index-1;
                // se i layout e' right oppure e' stata rimossa la colonna a sinistra perche' non ci sono azioni
                // l'indice dei dati corrisponde all'indice delle colonne, altrimenti devo togliere 1
                var i = ((self.config.actions_layout == 'right') ||
                    (! self._hasNeedSelectionAction() && ! self._hasRecordActions())) ? index:index-1;
                var field = self.visibleKeys[i];
                console.log('check',field);
                if (self.data.summary[field]) {
                    for (var operationKey in self.config.summary_fields[field]) {
                        var operation = self.config.summary_fields[field][operationKey];
                        var value = parseFloat(self.data.summary[field][operationKey]);
                        if (!isNaN(operation.decimal)) {
                            value = value.toFixed(operation.decimal);
                        }
                        var html = $.getTemplate(summaryTplId,{
                            operation : $.translate('general-summary_'+operationKey),
                            value : value + (operation.symbol ? ' ' + operation.symbol : ''),
                        })
                        console.log('salvo html',summaryTplId,html);
                        $(td).append(html);
                    }
                }
            }
        })

    },

    _attachEvents : function (index) {
        var self = this;
        for (var key in self.renderObjs[index]) {
            var render = self.renderObjs[index][key];
            var pk = self.data.value[index].id;
            self._attachEvent(render,pk);
        }


    },

    _attachDetailEvents : function () {
        // aggangio eventi detail
        var self = this;
        $(self.config.container).find('[data-detail_button]').unbind('click');
        $(self.config.container).find('[data-detail_button]').click(function () {
            var key = $(this).attr('data-key');
            var rowdata_index = parseInt($(this).attr('data-rowdata_index'));
            var isopen = parseInt($(this).attr('data-isopen'));
            //console.log('detail button',key,rowdata_index,isopen);
            var tr = $(this).closest('tr');
            var detail_row_key = key + "_" + rowdata_index;

            if (isopen) {
                console.log('isopen rimuovo',key,rowdata_index);
                var rowContainer = $(tr).closest('tbody').find('[data-detail_row="' + detail_row_key + '"]');
                //tr.eq(tr.index()+1).remove();
                //tr.next().remove();
                rowContainer.remove();
                //self.config.detail_fields[key].rowContainer=null;
                $(this).attr('data-isopen',0);
                return ;
            }

            $(this).attr('data-isopen',1);

            var modelData = self.data.value[rowdata_index];

            var tplData = {'detail_row_key':detail_row_key,'colspan':(self.visibleKeys.length+1)};

            var rowTemplate = $.getTemplate('#default_view_detail_field_tpl',tplData);



            tr.after(rowTemplate);
            // tr.after('<tr data-detail_row="' + detail_row_key + '" >' +
            //     '<td colspan="'+ (self.visibleKeys.length+1) + '"></td>' +
            //     '</tr>');
            var rowContainer = $(tr).closest('tbody').find('[data-detail_row="' + detail_row_key + '"]');
            $(rowContainer).find('[data-detail_title]').html($.translate(Utility.camelCase(self.modelName)+'-'+key));
            console.log('NON open visualizzo',detail_row_key,rowContainer);
            var detailContainer = rowContainer.find('[data-detail_container]');
            var func = self.config.detail_fields[key].func;
            //self.config.detail_fields[key].rowContainer = rowContainer;
            //console.log(detailContainer,modelData);
            func(detailContainer,modelData);
            return ;
        });
    },
    _buildFunctionParams : function (index,func) {
        var self = this;
        var params = {};
        var args = func.toString ().match (/function\s*\w*\s*\((.*?)\)/)[1].split (/\s*,\s*/);
        for (var a in args)
            params[args[a] ] = self.data.value[index][ args[a] ];
        return  _.values(params);
    },
    _evaluateFunctionProp : function (index,prop) {
        var self = this;
        if ( ! (index === null) && _.isFunction(prop)) {
            var fValues = self._buildFunctionParams(index,prop);
            return prop.apply(null, fValues);
        }
        return prop;
    },
    fireToConnected : function (evt) {
        var self = this;
        return ;
        /* TODO da vedere
         if (self.connectedObjs[evt.key]) {
         for (var i in self.connectedObjs[evt.key]) {
         var destKey = self.connectedObjs[evt.key][i];
         var func = self.renderObjs[0][destKey].config.dependencies.action;
         var container = $(self.config.container).find(self.renderObjs[0][destKey].config.container);
         func.apply(self,[evt,container]);

         }
         }
         */
    },
    /**
     * ritorna tutte le pk delle rows selezionate.
     **/
    getChecked : function () {
        var self = this;
        var selected = [];
        $.each($(self.config.container).find('input[name="check_row"]:checked'),function () {
            selected.push($(this).attr('data-pk'));
        });
        return selected;
    },
    /**
     * restituisce l'oggetto data da assegnare all'oggetto render
     */
    _getRenderData : function (key,index,realType) {
        var self = this;
        var type = self._getRenderType(key);
        //if (realType)
        //    type = realType;
        // controllo che non ci sia definita una funzione speciale per i dati dell'oggetto render
        var funcName = '_get' + Render.getClassData(type) + 'Data';
        //log.debug(key + " check " + funcName);
        if (_.isFunction(self[funcName])) {
            return self[funcName](key,index);
        }
        var rdata = {
            value : self.data.value[index][key]
        };
        return rdata;
    },
    /**
     * funzione specifica per prendere i dati di un RenderCustom
     * @param key
     * @param index
     * @returns {{value: *, modelData: *}}
     * @private
     */
    _getRenderCustomData : function (key,index) {
        var self = this;
        var rdata =  {
            value : self.data.value[index][key],
            modelData : self.data.value[index]
        };
        return rdata;
    },
    _renderGlobalActions : function (actionConf) {
        var self = this;
        var actionsValues = [];
        for (var a in actionConf.actionData) {
            if (actionConf.actionData[a] instanceof RecordAction)
                continue
            var actionData = actionConf.actionData;
            var tmpValues = self._getTemplateActionData(null,actionData[a]);
            actionsValues.push(tmpValues);
        }
        var actHtml = $.getTemplate('#'+ self.prefixTemplateClass + '_view_global_action_tpl',{data:actionsValues});
        $(self.jQe).find('[data-view_row_actions]').html(actHtml);
    },

    _renderInfoHeader : function() {
        var self = this;
        $(self.jQe).find('[data-list_header]').html(self.data.list_header);
    },

    _render : function () {
        var self = this;
        if (self.visibleKeys.length)
            delete self.visibleKeys;
        self.visibleKeys = [];

        self._renderInfoHeader();

        if (self.data.value.length === 0) {
            self._renderZeroResult();
        } else {
            self._setKeys();
            self._setVisibleKeys();
            self._renderListHeader();
            self._renderPagination();
            self._renderHeader();
            self._renderFooter();
            self._createGrid();
            for (var i in self.data.value) {
                self._renderRow(i);
            }
            for (var i in self.data.value) {
                self._finalizeRow(i);
            }
            for (var i in self.data.value) {
                self._attachEvents(i);
            }
            self._attachDetailEvents();

        }

        self._renderActions();
    },

    _configViewCustomBase : function () {
        var self = this;
        // solo la prima volta mi prendo i riferimenti ai template
        var container = $.createDynamicContainer(self.config.container);;
        if (Object.keys(self._customAttrs) == 0) {
            //self._customAttrs.container = $(self.config.container);
            self._customAttrs.sourceContainer =  '#' + container.attr('id');
            //self._customAttrs.actionTpl = '#default_view_single_action_item_tpl';
            //self._customAttrs.actionGlobalTpl = '#default_view_global_action_tpl';
        }
    },
    _renderViewCustomBase : function () {
        var self = this;
        var tplData =  {
            items : self.data.value,
            pagination : self.data.pagination
        }
        $.renderTemplate($(self._customAttrs.sourceContainer),self.config.container,tplData);

    },
    /**
     * configurazione della view custom.
     * @private
     */
    _configViewCustomComplex : function () {
        var self = this;
        // solo la prima volta mi prendo i riferimenti ai template
        if (Object.keys(self._customAttrs) == 0) {
            self._customAttrs.container = $(self.config.container).find('[data-field="items"]');
            self._customAttrs.sourceHtml = $.getDomTemplate(self._customAttrs.container).html();
            self._customAttrs.actionTpl = '#default_view_single_action_item_tpl';
            self._customAttrs.actionGlobalTpl = '#default_view_global_action_tpl';
        }
    },
    /**
     * renderizza una viewList di tipo custom complex. Sono le view con gli oggetti render
     * descritti da tag e le configurazioni descritte nel model conf.
     * @private
     */
    _renderViewCustomComplex : function () {
        var self = this;

        $(self._customAttrs.container).html("");
        // cerco le global Action
        var configAction = self._getActionsConfig();
        var _findAction = function (name) {
            for (var i in configAction.actionData) {
                if (configAction.actionData[i].action == name)
                    return configAction.actionData[i];
            }
            return null;
        }

        $.each($(self.config.container).find('action'), function () {
            var name = $(this).attr('name');
            var actionData = _findAction(name);
            if (!actionData) {
                throw "action not found " + name;
            }
            var tplData = self._getTemplateActionData(0,actionData);
            var html = $.getTemplate(self._customAttrs.actionGlobalTpl, tplData);
            $(this).html(html);

        });

        // creo gli oggetti render
        for (var k in self.data.value) {
            $(self._customAttrs.container).append(self._customAttrs.sourceHtml);
            $.each($($(self._customAttrs.container).children()[k]).find('render'), function() {
                self._createRender(k,$(this).attr('data-field'),$(this));
            });
        }
        // chiamo la funzione render per ogni oggetto
        for (var i in self.renderObjs) {
            for (var k in self.renderObjs[i]) {
                self.renderObjs[i][k].render();
            }
        }
        // chiamo la funzione finalize per ogni oggetto
        for (var i in self.renderObjs) {
            for (var k in self.renderObjs[i]) {
                self.renderObjs[i][k].finalize();
            }
        }

        for (var i in self.data.value) {
            self._attachEvents(i);
        }

        self._renderPagination();
        // renderizzo evenutali azioni singole per record
        for (var k in self.data.value) {
            var itemContainer = $($(self._customAttrs.container).children()[k]);
            $.each($(itemContainer).find('action'), function () {
                //self._createRender(k, $(this).attr('data-field'), $(this));

                var name = $(this).attr('name');
                var actionData = _findAction(name);

                if (!actionData) {
                    throw "action not found " + name;
                }
                var tplData = self._getTemplateActionData(k,actionData);
                var html = $.getTemplate(self._customAttrs.actionTpl, tplData);
                $(this).html(html);

            });
        }
    },
    _setVisibleKeys : function () {
        var self = this;
        // calcolo le colonne visibili
        for (var i in self.keys) {
            if (self.config.fields_type[ self.keys[i] ] && self.config.fields_type[ self.keys[i] ].inputType == 'hidden')
                continue;
            self.visibleKeys.push(self.keys[i]);
        }
    },

    _renderZeroResult : function () {
        var self = this;
        var row = self.jQe.find('[data-view_row_elements]');
        row.find('td').html($.translate('Nessun elemento trovato'));
    },
    _renderPagination : function () {
        var self = this;
        if (!self.config.pagination) {
            self.jQe.find('[data-view_pagination]').remove();
            return ;
        }
        //console.log(self.data.pagination);
        var dy = $.createDynamicContainer('#default_view_list_pagination_tpl');
        $.renderTemplate(dy,dy,self.data.pagination);
        //console.log(dy.html());
        self.jQe.find('[data-view_pagination]').html(dy.html());
        dy.remove();

    },
    _renderListHeader : function () {
        var self = this;
        //console.log(self.data.pagination);
        // var dy = $.createDynamicContainer('#default_view_list_pagination_tpl');
        // $.renderTemplate(dy,dy,self.data.pagination);
        // self.jQe.find('[data-list_header]').html(dy.html());
        //console.log(dy.html());
        // dy.remove();
        var html = self.data.list_header;
        self.jQe.find('[data-list_header]').html(html);


    },

    _createRender : function (r,key,container) {
        var self = this;
        //log.debug('ViewCollection._createRender',r,key,container);
        var type = self._getRenderType(key);
        var classData = Render.getClassData(type);

        var rdata = self._getRenderData(key,r,classData);
        var rconfig = self._getRenderConfig(key,classData);
        rconfig.container = container;

        var render = Render.factory(key, _.extend(rconfig,rdata),type);

        if (!self.renderObjs[r])
            self.renderObjs[r] = {};

        self.renderObjs[r][key] = render;
        return render;


/*

        var type = self._getRenderType(key);
        var renderClass = Render.objType(type);
        var classData = Render.classData(type);

        var rdata = self._getRenderData(key,r,classData); //self._getRenderData(key,r,renderClass);
        var rconfig = self._getRenderConfig(key,renderClass);
        rconfig.container = container;
        var render = Render.factory(key, _.extend(rconfig,rdata),type);

        if (!self.renderObjs[r])
            self.renderObjs[r] = {};

        self.renderObjs[r][key] = render;
        return render;
        */
    },

    /**
     * renderizzo la riga con indice index
     * @param index
     * @private
     */
    _renderRow : function (index) {
        var self = this;
        var jQe = self.jQe;
        var rowContainer = jQe.find('[data-view_row_elements]').get(index);
        for (var i in self.keys) {
            var key = self.keys[i];
            var colIndex = $.inArray(key,self.visibleKeys);
            var container = null;
            if (colIndex >= 0) {
                if (self.config.actions_layout != 'right')
                    colIndex++;
                container = $( $(rowContainer).find('td').get(colIndex));
                container.addClass('field-'+key);
                // check se il campo e' associato un detail devo creare il template per il bottone detail
                if (self.config.detail_fields[key]) {
                    container.html($.getTemplate('#default_view_list_detail_tpl'));
                    container.find('[data-rowdata_index]').attr('data-rowdata_index',index);
                    container.find('[data-key]').attr('data-key',key);
                    container = container.find('[data-detail_container]');
                }
            }
            var r = self._createRender(index,key,container);
            r.render();
        }
        // assegno attributo alla colonna azioni
        var colAction = self.config.actions_layout != 'right'?0:self.visibleKeys.length;
        $( $(rowContainer).find('td').get(colAction)).attr('data-col_actions','');
    },
    /**
     * chiamo il finalize per ogni oggetto della riga
     * @param index
     * @private
     */
    _finalizeRow : function (index) {
        var self = this;
        var jQe = self.jQe;
        for (var i in self.keys) {
            self.renderObjs[index][self.keys[i]].finalize();
        }

    },
    _createGrid : function () {
        var self = this;
        var numRow = self.data.value.length;
        var numCol = self.visibleKeys.length;
        var jQe = self.jQe;
        var row = jQe.find('[data-view_row_elements]');
        var col = row.find('td');
        // clone le colonne
        for (var i=0;i<numCol;i++) {
            col.clone().appendTo(row);
        }
        row = jQe.find('tbody tr').first();
        //ora clono la prima riga
        for (var i=1;i<numRow;i++) {
            row.clone().prependTo( jQe.find('tbody') );
        }
    },

    _renderActions : function () {
        var self = this;
        if (self.config.actions.length === 0) {
            $(self.jQe).find('[data-col_actions]').remove();
            $(self.jQe).find('[data-view_row_actions]').remove();
            return ;
        }
        var actionConf = self._getActionsConfig();
        self._renderSingleActions(actionConf);
        self._renderGlobalActions(actionConf);
    },
    /**
     * prende i dati per la renderizzazione del template action.
     * @param row: indice di riga
     * @param actionObject : oggetto azione
     * @returns {*} ritorna un array associativo per il template da renderizzare
     * @private
     */
    _getTemplateActionData :  function (row,actionObject) {
        var self = this;
        var tplData = null;
        if (actionObject instanceof RecordAction) {
            tplData = new RecordAction(actionObject);
        } else {
            tplData = new CollectionAction(actionObject);
        }

        tplData.pk = (row===null)?null:self.data.value[row].id;
        tplData.actionText = self._evaluateFunctionProp(row,actionObject.actionText);
        tplData.actionIcon = self._evaluateFunctionProp(row,actionObject.actionIcon);
        tplData.actionTitle = self._evaluateFunctionProp(row,actionObject.actionTitle);
        tplData.actionClass = self._evaluateFunctionProp(row,actionObject.actionClass);
        tplData.visible = self._evaluateFunctionProp(row,actionObject.visible);
        tplData.enabled = self._evaluateFunctionProp(row,actionObject.enabled);
        tplData.target = self._evaluateFunctionProp(row,actionObject.target);
        tplData.href = null;
        tplData.params = (row===null)?[]:self._buildFunctionParams(row,actionObject.func);
        if (tplData.control_type == 'link') {
            actionObject.view = self;
            tplData.href = actionObject.func.apply(actionObject, tplData.params);
            tplData.target = self._evaluateFunctionProp(row,actionObject.target);
        }
        tplData.params = JSON.stringify(tplData.params);
        return tplData;
    },

    _getActionsConfig : function () {
        var self = this;
        var actionData =  [];
        var needSelection = false;
        // recupero le azioni singole presenti e controllo se sono di default o custom
        for (var i in self.config.actions) {
            var akey = self.config.actions[i];
            if (self.config.extra_actions[akey]) {
                needSelection = needSelection || self.config.extra_actions[akey].needSelection;
                var extra_action = self._buildSingleAction(akey,self.config.extra_actions[akey]);
                actionData.push(extra_action);
            } else if (defaultSingleActions[akey]) {
                actionData.push(defaultSingleActions[akey]);
            } else if (defaultGlobalActions[akey]) {
                needSelection = needSelection || defaultGlobalActions[akey].needSelection;
                actionData.push(defaultGlobalActions[akey]);
                //hasGlobalAction = true;
            } else {
                log.warn('Action not found with key ' + akey);
            }
        }
        // basta che un azione contenga la needselection che devo disegnare le checkbox
        return {actionData:actionData,needSelection : needSelection};
    },


    _renderSingleActions : function (actionConf) {
        var self = this;

        //var actionConf = self._getActionsConfig();
        // le associo ad ogni riga
        var numRow = self.data.value.length;
        for (var i=0;i<numRow;i++) {
            var actionsValues = [];
            for (var a in actionConf.actionData) {
                //console.log("check istance ",actionConf.actionData[a].action,actionConf.actionData[a] instanceof CollectionAction );
                if (actionConf.actionData[a] instanceof CollectionAction)
                    continue
                var actionData = actionConf.actionData;
                //var needSelection = actionConf.needSelection;
                var tmpValues = self._getTemplateActionData(i,actionData[a]);
                actionsValues.push(tmpValues);
            }
            var rowContainer = self.jQe.find('[data-view_row_elements]').get(i);
            //in questo caso posso eliminare l'intera colonna
            if (actionsValues.length == 0 && !actionConf.needSelection) {
                $( $(rowContainer)).find('[data-col_actions]').remove();
                continue;
            }
            log.debug('ViewCollection._renderSingleActions  actionValues',actionsValues[i]);
            var actHtml = $.getTemplate('#'+ self.prefixTemplateClass + '_view_single_action_tpl',{pk:self.data.value[i].id,data:actionsValues});

            $( $(rowContainer)).find('[data-col_actions]').html(actHtml);

            if (!actionConf.needSelection) {
                $( $(rowContainer)).find('[data-col_actions]').find('[data-check]').remove();
            }
        }

    },
    /**
     * controlla che la lista abbia l'azione removeAll perche' se non c'e' l'ha non
     * @private
     */
    _hasNeedSelectionAction : function () {
        var self = this;
        for (var i in self.config.actions) {
            var akey = self.config.actions[i];
            if (defaultGlobalActions[akey] && defaultGlobalActions[akey].needSelection) {
                return true;
            }
            if (self.config.extra_actions[akey] && self.config.extra_actions[akey].needSelection) {
                return true;
            }
        }
        return false;
    },
    /**
     * controlla se la view ha almeno una azione che lavora sul singolo record della lista
     * @returns {boolean}
     * @private
     */
    _hasRecordActions : function () {
        var self = this;
        for (var i in self.config.actions) {
            var akey = self.config.actions[i];
            if (defaultSingleActions[akey])
                return true;
            if (self.config.extra_actions[akey] instanceof RecordAction)
                return true;
        }
        return false;
    }
});
